import config from 'src/config';
import engineApiSlice from 'src/shared/state/api-slices/engineApiSlice';
import { executeEngineQuery } from 'src/app/portfolio/state/api/engineQueryUtils';
import { adminSitesQuery, type AdminSitesResult, type GqlSiteSortField, type GqlSortDirection } from './adminSitesQuery';
import type { SiteStatus } from './organisationEngineSlice';

export type AdminSitesQueryArgs = {
    businessCentralId: string;
    status: SiteStatus;
    page?: number;
    pageSize?: number;
    sortBy?: GqlSiteSortField;
    sortDir?: GqlSortDirection;
    nameContains?: string;
};

const engineGraphqlEndpoint = `${config.engineApiUrl.replace(/\/$/, '')}/query`;

const adminSitesEngineSlice = engineApiSlice.injectEndpoints({
    endpoints: builder => ({
        getAdminSites: builder.query<AdminSitesResult, AdminSitesQueryArgs>({
            queryFn: arg =>
                executeEngineQuery<AdminSitesResult>(engineGraphqlEndpoint, adminSitesQuery, {
                    businessCentralId: arg.businessCentralId,
                    status: arg.status.toUpperCase(),
                    page: arg.page ?? 1,
                    pageSize: arg.pageSize ?? 100,
                    sortBy: arg.sortBy,
                    sortDir: arg.sortDir,
                    nameContains: arg.nameContains,
                }),
            providesTags: (_result, _error, arg) => [{ type: 'sites' as const, id: arg.businessCentralId }],
        }),
    }),
});

export const { useGetAdminSitesQuery } = adminSitesEngineSlice;
